// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/service_account.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import type { Subject } from "./identity_pb";
import { file_gitpod_v1_identity } from "./identity_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/service_account.proto.
 */
export const file_gitpod_v1_service_account: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_v1_identity, file_gitpod_v1_pagination, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.CreateServiceAccountRequest
 */
export type CreateServiceAccountRequest = Message<"gitpod.v1.CreateServiceAccountRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * valid_until specifies when this service account expires.
   * Note: In the current design, the service account itself has an expiry.
   * All authentication using this service account will fail after this time.
   *
   * @generated from field: google.protobuf.Timestamp valid_until = 3;
   */
  validUntil?: Timestamp;
};

/**
 * Describes the message gitpod.v1.CreateServiceAccountRequest.
 * Use `create(CreateServiceAccountRequestSchema)` to create a new message.
 */
export const CreateServiceAccountRequestSchema: GenMessage<CreateServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 0);

/**
 * @generated from message gitpod.v1.CreateServiceAccountResponse
 */
export type CreateServiceAccountResponse = Message<"gitpod.v1.CreateServiceAccountResponse"> & {
  /**
   * @generated from field: gitpod.v1.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount;
};

/**
 * Describes the message gitpod.v1.CreateServiceAccountResponse.
 * Use `create(CreateServiceAccountResponseSchema)` to create a new message.
 */
export const CreateServiceAccountResponseSchema: GenMessage<CreateServiceAccountResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 1);

/**
 * @generated from message gitpod.v1.ListServiceAccountsRequest
 */
export type ListServiceAccountsRequest = Message<"gitpod.v1.ListServiceAccountsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * filter contains options for filtering the list of service accounts.
   *
   * @generated from field: gitpod.v1.ListServiceAccountsRequest.Filter filter = 2;
   */
  filter?: ListServiceAccountsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListServiceAccountsRequest.
 * Use `create(ListServiceAccountsRequestSchema)` to create a new message.
 */
export const ListServiceAccountsRequestSchema: GenMessage<ListServiceAccountsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 2);

/**
 * @generated from message gitpod.v1.ListServiceAccountsRequest.Filter
 */
export type ListServiceAccountsRequest_Filter = Message<"gitpod.v1.ListServiceAccountsRequest.Filter"> & {
  /**
   * include_suspended includes suspended (soft-deleted) service accounts in the response.
   * By default, suspended service accounts are excluded.
   *
   * @generated from field: bool include_suspended = 1;
   */
  includeSuspended: boolean;

  /**
   * service_account_ids filters the response to only service accounts with the specified IDs
   *
   * @generated from field: repeated string service_account_ids = 2;
   */
  serviceAccountIds: string[];

  /**
   * search performs case-insensitive search across service account name, description, and ID
   *
   * @generated from field: string search = 3;
   */
  search: string;
};

/**
 * Describes the message gitpod.v1.ListServiceAccountsRequest.Filter.
 * Use `create(ListServiceAccountsRequest_FilterSchema)` to create a new message.
 */
export const ListServiceAccountsRequest_FilterSchema: GenMessage<ListServiceAccountsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 2, 0);

/**
 * @generated from message gitpod.v1.ListServiceAccountsResponse
 */
export type ListServiceAccountsResponse = Message<"gitpod.v1.ListServiceAccountsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.ServiceAccount service_accounts = 2;
   */
  serviceAccounts: ServiceAccount[];
};

/**
 * Describes the message gitpod.v1.ListServiceAccountsResponse.
 * Use `create(ListServiceAccountsResponseSchema)` to create a new message.
 */
export const ListServiceAccountsResponseSchema: GenMessage<ListServiceAccountsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 3);

/**
 * @generated from message gitpod.v1.GetServiceAccountRequest
 */
export type GetServiceAccountRequest = Message<"gitpod.v1.GetServiceAccountRequest"> & {
  /**
   * @generated from field: string service_account_id = 1;
   */
  serviceAccountId: string;
};

/**
 * Describes the message gitpod.v1.GetServiceAccountRequest.
 * Use `create(GetServiceAccountRequestSchema)` to create a new message.
 */
export const GetServiceAccountRequestSchema: GenMessage<GetServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 4);

/**
 * @generated from message gitpod.v1.GetServiceAccountResponse
 */
export type GetServiceAccountResponse = Message<"gitpod.v1.GetServiceAccountResponse"> & {
  /**
   * @generated from field: gitpod.v1.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount;
};

/**
 * Describes the message gitpod.v1.GetServiceAccountResponse.
 * Use `create(GetServiceAccountResponseSchema)` to create a new message.
 */
export const GetServiceAccountResponseSchema: GenMessage<GetServiceAccountResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 5);

/**
 * @generated from message gitpod.v1.UpdateServiceAccountRequest
 */
export type UpdateServiceAccountRequest = Message<"gitpod.v1.UpdateServiceAccountRequest"> & {
  /**
   * @generated from field: string service_account_id = 1;
   */
  serviceAccountId: string;

  /**
   * Optional fields for update
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Note: valid_until is immutable and cannot be updated
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;
};

/**
 * Describes the message gitpod.v1.UpdateServiceAccountRequest.
 * Use `create(UpdateServiceAccountRequestSchema)` to create a new message.
 */
export const UpdateServiceAccountRequestSchema: GenMessage<UpdateServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 6);

/**
 * @generated from message gitpod.v1.UpdateServiceAccountResponse
 */
export type UpdateServiceAccountResponse = Message<"gitpod.v1.UpdateServiceAccountResponse"> & {
  /**
   * @generated from field: gitpod.v1.ServiceAccount service_account = 1;
   */
  serviceAccount?: ServiceAccount;
};

/**
 * Describes the message gitpod.v1.UpdateServiceAccountResponse.
 * Use `create(UpdateServiceAccountResponseSchema)` to create a new message.
 */
export const UpdateServiceAccountResponseSchema: GenMessage<UpdateServiceAccountResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 7);

/**
 * @generated from message gitpod.v1.DeleteServiceAccountRequest
 */
export type DeleteServiceAccountRequest = Message<"gitpod.v1.DeleteServiceAccountRequest"> & {
  /**
   * @generated from field: string service_account_id = 1;
   */
  serviceAccountId: string;
};

/**
 * Describes the message gitpod.v1.DeleteServiceAccountRequest.
 * Use `create(DeleteServiceAccountRequestSchema)` to create a new message.
 */
export const DeleteServiceAccountRequestSchema: GenMessage<DeleteServiceAccountRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 8);

/**
 * @generated from message gitpod.v1.DeleteServiceAccountResponse
 */
export type DeleteServiceAccountResponse = Message<"gitpod.v1.DeleteServiceAccountResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteServiceAccountResponse.
 * Use `create(DeleteServiceAccountResponseSchema)` to create a new message.
 */
export const DeleteServiceAccountResponseSchema: GenMessage<DeleteServiceAccountResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 9);

/**
 * @generated from message gitpod.v1.CreateServiceAccountAccessTokenRequest
 */
export type CreateServiceAccountAccessTokenRequest = Message<"gitpod.v1.CreateServiceAccountAccessTokenRequest"> & {
  /**
   * @generated from field: string service_account_id = 1;
   */
  serviceAccountId: string;
};

/**
 * Describes the message gitpod.v1.CreateServiceAccountAccessTokenRequest.
 * Use `create(CreateServiceAccountAccessTokenRequestSchema)` to create a new message.
 */
export const CreateServiceAccountAccessTokenRequestSchema: GenMessage<CreateServiceAccountAccessTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 10);

/**
 * @generated from message gitpod.v1.CreateServiceAccountAccessTokenResponse
 */
export type CreateServiceAccountAccessTokenResponse = Message<"gitpod.v1.CreateServiceAccountAccessTokenResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message gitpod.v1.CreateServiceAccountAccessTokenResponse.
 * Use `create(CreateServiceAccountAccessTokenResponseSchema)` to create a new message.
 */
export const CreateServiceAccountAccessTokenResponseSchema: GenMessage<CreateServiceAccountAccessTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 11);

/**
 * @generated from message gitpod.v1.ServiceAccount
 */
export type ServiceAccount = Message<"gitpod.v1.ServiceAccount"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: gitpod.v1.Subject creator = 5;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp valid_until = 7;
   */
  validUntil?: Timestamp;

  /**
   * suspended indicates whether the service account has been deleted (soft-delete).
   * Suspended service accounts cannot be used for authentication.
   *
   * @generated from field: bool suspended = 8;
   */
  suspended: boolean;

  /**
   * system_managed indicates whether this is a system-managed service account.
   * System-managed service accounts cannot be modified or deleted by users.
   *
   * @generated from field: bool system_managed = 9;
   */
  systemManaged: boolean;
};

/**
 * Describes the message gitpod.v1.ServiceAccount.
 * Use `create(ServiceAccountSchema)` to create a new message.
 */
export const ServiceAccountSchema: GenMessage<ServiceAccount> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 12);

/**
 * ServiceAccountToken represents metadata about a service account token.
 * The actual token value is only returned once during creation.
 *
 * @generated from message gitpod.v1.ServiceAccountToken
 */
export type ServiceAccountToken = Message<"gitpod.v1.ServiceAccountToken"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string service_account_id = 2;
   */
  serviceAccountId: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: gitpod.v1.Subject creator = 4;
   */
  creator?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_used = 7;
   */
  lastUsed?: Timestamp;
};

/**
 * Describes the message gitpod.v1.ServiceAccountToken.
 * Use `create(ServiceAccountTokenSchema)` to create a new message.
 */
export const ServiceAccountTokenSchema: GenMessage<ServiceAccountToken> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 13);

/**
 * @generated from message gitpod.v1.CreateServiceAccountTokenRequest
 */
export type CreateServiceAccountTokenRequest = Message<"gitpod.v1.CreateServiceAccountTokenRequest"> & {
  /**
   * @generated from field: string description = 1;
   */
  description: string;

  /**
   * valid_for specifies how long the token should be valid.
   * A large value (e.g. reaching year 2099) represents "no expiry".
   * The actual expiry is always capped to the service account's own expiry.
   *
   * @generated from field: google.protobuf.Duration valid_for = 2;
   */
  validFor?: Duration;
};

/**
 * Describes the message gitpod.v1.CreateServiceAccountTokenRequest.
 * Use `create(CreateServiceAccountTokenRequestSchema)` to create a new message.
 */
export const CreateServiceAccountTokenRequestSchema: GenMessage<CreateServiceAccountTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 14);

/**
 * @generated from message gitpod.v1.CreateServiceAccountTokenResponse
 */
export type CreateServiceAccountTokenResponse = Message<"gitpod.v1.CreateServiceAccountTokenResponse"> & {
  /**
   * token is the actual JWT token value. This is only returned once during creation.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * service_account_token contains the token metadata.
   *
   * @generated from field: gitpod.v1.ServiceAccountToken service_account_token = 2;
   */
  serviceAccountToken?: ServiceAccountToken;
};

/**
 * Describes the message gitpod.v1.CreateServiceAccountTokenResponse.
 * Use `create(CreateServiceAccountTokenResponseSchema)` to create a new message.
 */
export const CreateServiceAccountTokenResponseSchema: GenMessage<CreateServiceAccountTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 15);

/**
 * @generated from message gitpod.v1.ListServiceAccountTokensRequest
 */
export type ListServiceAccountTokensRequest = Message<"gitpod.v1.ListServiceAccountTokensRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListServiceAccountTokensRequest.
 * Use `create(ListServiceAccountTokensRequestSchema)` to create a new message.
 */
export const ListServiceAccountTokensRequestSchema: GenMessage<ListServiceAccountTokensRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 16);

/**
 * @generated from message gitpod.v1.ListServiceAccountTokensResponse
 */
export type ListServiceAccountTokensResponse = Message<"gitpod.v1.ListServiceAccountTokensResponse"> & {
  /**
   * @generated from field: repeated gitpod.v1.ServiceAccountToken tokens = 1;
   */
  tokens: ServiceAccountToken[];

  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;
};

/**
 * Describes the message gitpod.v1.ListServiceAccountTokensResponse.
 * Use `create(ListServiceAccountTokensResponseSchema)` to create a new message.
 */
export const ListServiceAccountTokensResponseSchema: GenMessage<ListServiceAccountTokensResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 17);

/**
 * @generated from message gitpod.v1.GetServiceAccountTokenRequest
 */
export type GetServiceAccountTokenRequest = Message<"gitpod.v1.GetServiceAccountTokenRequest"> & {
  /**
   * @generated from field: string service_account_token_id = 1;
   */
  serviceAccountTokenId: string;
};

/**
 * Describes the message gitpod.v1.GetServiceAccountTokenRequest.
 * Use `create(GetServiceAccountTokenRequestSchema)` to create a new message.
 */
export const GetServiceAccountTokenRequestSchema: GenMessage<GetServiceAccountTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 18);

/**
 * @generated from message gitpod.v1.GetServiceAccountTokenResponse
 */
export type GetServiceAccountTokenResponse = Message<"gitpod.v1.GetServiceAccountTokenResponse"> & {
  /**
   * @generated from field: gitpod.v1.ServiceAccountToken token = 1;
   */
  token?: ServiceAccountToken;
};

/**
 * Describes the message gitpod.v1.GetServiceAccountTokenResponse.
 * Use `create(GetServiceAccountTokenResponseSchema)` to create a new message.
 */
export const GetServiceAccountTokenResponseSchema: GenMessage<GetServiceAccountTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 19);

/**
 * @generated from message gitpod.v1.DeleteServiceAccountTokenRequest
 */
export type DeleteServiceAccountTokenRequest = Message<"gitpod.v1.DeleteServiceAccountTokenRequest"> & {
  /**
   * @generated from field: string service_account_token_id = 1;
   */
  serviceAccountTokenId: string;
};

/**
 * Describes the message gitpod.v1.DeleteServiceAccountTokenRequest.
 * Use `create(DeleteServiceAccountTokenRequestSchema)` to create a new message.
 */
export const DeleteServiceAccountTokenRequestSchema: GenMessage<DeleteServiceAccountTokenRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 20);

/**
 * @generated from message gitpod.v1.DeleteServiceAccountTokenResponse
 */
export type DeleteServiceAccountTokenResponse = Message<"gitpod.v1.DeleteServiceAccountTokenResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteServiceAccountTokenResponse.
 * Use `create(DeleteServiceAccountTokenResponseSchema)` to create a new message.
 */
export const DeleteServiceAccountTokenResponseSchema: GenMessage<DeleteServiceAccountTokenResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_service_account, 21);

/**
 * @generated from service gitpod.v1.ServiceAccountService
 */
export const ServiceAccountService: GenService<{
  /**
   * Creates a new service account in an organization.
   *
   * Use this method to:
   * - Create service accounts for automation
   * - Set up CI/CD credentials
   * - Configure programmatic access
   *
   * ### Examples
   *
   * - Create service account:
   *
   *   Creates a service account for automation.
   *
   *   ```yaml
   *   name: "ci-pipeline"
   *   description: "CI/CD Pipeline"
   *   validUntil: "2025-12-31T23:59:59Z"
   *   ```
   *
   * @generated from rpc gitpod.v1.ServiceAccountService.CreateServiceAccount
   */
  createServiceAccount: {
    methodKind: "unary";
    input: typeof CreateServiceAccountRequestSchema;
    output: typeof CreateServiceAccountResponseSchema;
  },
  /**
   * Lists service accounts in an organization.
   *
   * Use this method to:
   * - View all service accounts
   * - Audit service account usage
   * - Manage service account lifecycle
   *
   * ### Examples
   *
   * - List service accounts:
   *
   *   Shows all service accounts in an organization.
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.ServiceAccountService.ListServiceAccounts
   */
  listServiceAccounts: {
    methodKind: "unary";
    input: typeof ListServiceAccountsRequestSchema;
    output: typeof ListServiceAccountsResponseSchema;
  },
  /**
   * Gets details about a specific service account.
   *
   * Use this method to:
   * - View service account details
   * - Check service account status
   * - Retrieve service account metadata
   *
   * ### Examples
   *
   * - Get service account:
   *
   *   Retrieves details about a specific service account.
   *
   *   ```yaml
   *   serviceAccountId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.ServiceAccountService.GetServiceAccount
   */
  getServiceAccount: {
    methodKind: "unary";
    input: typeof GetServiceAccountRequestSchema;
    output: typeof GetServiceAccountResponseSchema;
  },
  /**
   * Updates a service account.
   *
   * Use this method to:
   * - Update service account name or description
   *
   * ### Examples
   *
   * - Update name and description:
   *
   *   Updates the service account name and description.
   *
   *   ```yaml
   *   serviceAccountId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   name: "updated-ci-pipeline"
   *   description: "Updated CI/CD Pipeline"
   *   ```
   *
   * @generated from rpc gitpod.v1.ServiceAccountService.UpdateServiceAccount
   */
  updateServiceAccount: {
    methodKind: "unary";
    input: typeof UpdateServiceAccountRequestSchema;
    output: typeof UpdateServiceAccountResponseSchema;
  },
  /**
   * Deletes a service account.
   *
   * Use this method to:
   * - Remove unused service accounts
   * - Revoke service account access
   * - Clean up expired accounts
   *
   * ### Examples
   *
   * - Delete service account:
   *
   *   Permanently removes a service account.
   *
   *   ```yaml
   *   serviceAccountId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.ServiceAccountService.DeleteServiceAccount
   */
  deleteServiceAccount: {
    methodKind: "unary";
    input: typeof DeleteServiceAccountRequestSchema;
    output: typeof DeleteServiceAccountResponseSchema;
  },
  /**
   * Creates a short-lived access token for configuring a service account.
   *
   * The token expires after 30 minutes and can be used as a Bearer token
   * in the Authorization header to perform operations on behalf of the
   * service account, such as configuring OAuth.
   *
   * ### Examples
   *
   * - Create access token:
   *
   *   ```yaml
   *   serviceAccountId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.ServiceAccountService.CreateServiceAccountAccessToken
   */
  createServiceAccountAccessToken: {
    methodKind: "unary";
    input: typeof CreateServiceAccountAccessTokenRequestSchema;
    output: typeof CreateServiceAccountAccessTokenResponseSchema;
  },
  /**
   * Creates a long-lived token for a service account.
   *
   * Use this method to:
   * - Create tokens for CI/CD pipelines
   * - Set up automation credentials
   * - Generate API access tokens
   *
   * The token is returned only once and cannot be retrieved later.
   * Token validity is capped to the service account's expiry.
   *
   * Requires impersonation: First obtain a short-lived access token via
   * CreateServiceAccountAccessToken, then use it to call this method.
   * The service account ID is derived from the caller's identity.
   *
   * ### Examples
   *
   * - Create token with 90-day validity:
   *
   *   ```yaml
   *   description: "GitHub Actions"
   *   validFor: "7776000s"
   *   ```
   *
   * @generated from rpc gitpod.v1.ServiceAccountService.CreateServiceAccountToken
   */
  createServiceAccountToken: {
    methodKind: "unary";
    input: typeof CreateServiceAccountTokenRequestSchema;
    output: typeof CreateServiceAccountTokenResponseSchema;
  },
  /**
   * Lists tokens for a service account.
   *
   * Use this method to:
   * - View all tokens for a service account
   * - Audit token usage
   * - Identify tokens to revoke
   *
   * Requires impersonation: First obtain a short-lived access token via
   * CreateServiceAccountAccessToken, then use it to call this method.
   * The service account ID is derived from the caller's identity.
   *
   * ### Examples
   *
   * - List tokens:
   *
   *   ```yaml
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.ServiceAccountService.ListServiceAccountTokens
   */
  listServiceAccountTokens: {
    methodKind: "unary";
    input: typeof ListServiceAccountTokensRequestSchema;
    output: typeof ListServiceAccountTokensResponseSchema;
  },
  /**
   * Gets details about a specific service account token.
   *
   * Use this method to:
   * - View token metadata
   * - Check token expiration
   * - Monitor token usage
   *
   * ### Examples
   *
   * - Get token details:
   *
   *   ```yaml
   *   serviceAccountTokenId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.ServiceAccountService.GetServiceAccountToken
   */
  getServiceAccountToken: {
    methodKind: "unary";
    input: typeof GetServiceAccountTokenRequestSchema;
    output: typeof GetServiceAccountTokenResponseSchema;
  },
  /**
   * Deletes a service account token.
   *
   * Use this method to:
   * - Revoke token access
   * - Remove compromised tokens
   * - Rotate credentials
   *
   * ### Examples
   *
   * - Delete token:
   *
   *   ```yaml
   *   serviceAccountTokenId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.ServiceAccountService.DeleteServiceAccountToken
   */
  deleteServiceAccountToken: {
    methodKind: "unary";
    input: typeof DeleteServiceAccountTokenRequestSchema;
    output: typeof DeleteServiceAccountTokenResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_service_account, 0);

